"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EscortType_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var EscortType_Factory = /** @class */ (function () {
    function EscortType_Factory() {
    }
    EscortType_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
        };
        return result;
    };
    EscortType_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
        };
        return result;
    };
    return EscortType_Factory;
}());
exports.EscortType_Factory = EscortType_Factory;
